import { SERVICE_GROUP_ID } from '@/constants';

// eMBA2.0: 2, GLOBIS 学び放題プラス（旧）: 3
export const isDisplaySubscriptionList = (serviceId: number) =>
  [SERVICE_GROUP_ID.emba, SERVICE_GROUP_ID.hodaiplus].includes(serviceId);
